import { getGAClientIdFromGTM } from "@product/scmp-sdk";
import { config } from "shared/data";
export const getGoogleAnalyticsClientIdSync = () => {
  var _ga, _ga$getAll;
  if (typeof ga === "undefined") return;
  const instance = (_ga = ga) === null || _ga === void 0 || (_ga$getAll = _ga.getAll) === null || _ga$getAll === void 0 || (_ga$getAll = _ga$getAll.call(_ga)) === null || _ga$getAll === void 0 ? void 0 : _ga$getAll[0];
  if (!instance) return;
  return instance.get("clientId");
};
export const getGoogleAnalyticsClientId = () => getGoogleAnalyticsClientIdSync() ?? getGAClientIdFromGTM(config.googleAnalytics.measurementId);